export default "__VITE_ASSET__ENF2XDmM__"